module.exports = __webpack_public_path__ + "img/bg02.491f846f.png";